import React, { useState, useEffect } from 'react'
import SubHeader from '../general/SubHeader';

const AdminEnquiry = () => {
  const [enquiry, setEnquiry] = useState([]);

  // fetch contact form submission enquiry from backend
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await fetch('https://apis.anvifoundation.com/omanshi/get-contact');
        const data = await response.json();

        if (response.ok) {
          setEnquiry(data); // Store the fetched sites in state
        } else {
          console.error('Failed to fetch enquiries:', data);
        }
      } catch (error) {
        console.error('Error while fetching enquiries:', error);
      }
    };

    fetchEnquiry();
  }, []); // Empty dependency array means it runs once when the component mounts


  return (
    <>
      <SubHeader message="Enquiry" />

      <section className='py-5 bg-light'>
        <div className='container text-center px-lg-5 px-3'>

          <p className='sec-subheading'>Contact Form Submissions</p>
          {/* <p className='sec-heading'>Enquiries Received</p> */}

          <div className='table-responsive mt-4'>
            <table className='table w-100'>

              <tr className='bg-white'>
                <th className='px-3 py-3'>S No</th>
                <th className='px-3 py-3'>Name</th>
                <th className='px-3 py-3'>Phone</th>
                <th className='px-3 py-3'>Email</th>
                <th className='px-3 py-3'>Message</th>
              </tr>

              {enquiry.length > 0 ? (
                enquiry.map((enquiries, index) => (
                  <tr key={enquiries.id}>
                    <td className='px-3 py-2'>{index + 1}</td>
                    <td className='px-3 py-2'>{enquiries.name}</td>
                    <td className='px-3 py-2'>{enquiries.phone}</td>
                    <td className='px-3 py-2'>{enquiries.email}</td>
                    <td className='px-3 py-2'>{enquiries.message}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className='px-3 py-2'>No Enquiry Submission</td></tr>
              )}

            </table>
          </div>


        </div>
      </section>
    </>
  )
}

export default AdminEnquiry
